import React, {useEffect, useState} from "react";
import {useAppDispatch, useAppSelector} from 'redux/hooks'
import {checkPermissions} from "../../../../redux/permissions/permissionsUtils";
import {ProgressBar} from "primereact/progressbar";
import {classNames} from "primereact/utils";
import {setDialogVisible, setEditType, setErrorFields, setSelectedCompanyIndex} from "../../../../redux/actions/actions";
import {getNotification, updateStateCampaign} from "../../../../redux/api/api";
import {Button} from "primereact/button";
import {getItem} from "../../../../redux/cache/cacheService";
import {codes} from "../../../../redux/notificationCodes";
import {ConfirmDialog} from "primereact/confirmdialog";
import {Divider} from "primereact/divider";
import {DataTable} from "primereact/datatable";
import {Column} from "primereact/column";
import {useNavigate} from "react-router-dom";
import {SET_USER_STATUS_SUCCESS} from "../../../../redux/types/typesUsersList";
import {weekdayField} from "../../../../dictionaries";
import {Calendar} from "primereact/calendar";
import {assignedPhoneIsInactive, assignedTrunkIsInactive, TrunkInactiveIcon, trunkInactiveLabel} from "../../../../utils/trunkActivity";

const CompaniesListDetails = (props: any) => {
    const dispatch = useAppDispatch();
    const rolesVision = useAppSelector(state => state.RolesReducer.rolesVision) as unknown as Record<string, string[]>;
    const dialerPermissions = checkPermissions(rolesVision, 'Campaigns');
    const loader = useAppSelector(state => state.CompaniesListReducer.detailsLoading);
    const companiesData = useAppSelector(state => state.CompaniesListReducer.companiesData)
    const archiveTableToggle = useAppSelector(state => state.CompaniesListReducer.archiveTableToggle);
    const campaignContactsPageSize = useAppSelector(state => state.CompaniesListReducer.campaignContactsPageSize);
    const user = useAppSelector(state => state.UsersReducer.userData);
    let statusId = companiesData?.campaign?.statusId;
    // const statusDone = companiesData?.campaign?.statusId === 6;
    const statusDone = false;
    const companiesDirectoryCampaignType = useAppSelector(state => state.CompaniesListReducer.companiesDirectoryCampaignType)
    const companies = useAppSelector(state => state.CompaniesListReducer)
    const [windowWidth, setWindowWidth] = useState(window.innerWidth);
    const [cancelNotificationStatusChange, setCancelNotificationStatusChange] = useState<boolean>(false);
    const [launchNotificationStatusChange, setLaunchNotificationStatusChange] = useState<boolean>(false);
    const [suspendNotificationStatusChange, setSuspendNotificationStatusChange] = useState<boolean>(false);
    const jwtToken = useAppSelector(state => state.UsersReducer.userData.jwtToken);
    const companiesDirectoryTranksPhones = useAppSelector(state => state.CompaniesListReducer.companiesDirectoryTranksPhones);
    const [updatedScheduler, setUpdatedScheduler] = useState<any>(null);
    const branches = useAppSelector(state => state.UsersListReducer.branches);
    const companiesDirectoryCampaignStrategy = useAppSelector(state => state.CompaniesListReducer.companiesDirectoryCampaignStrategy)
    const strategy = companiesDirectoryCampaignStrategy?.find(
        (item: { dictionaryId: any; }) => item.dictionaryId === companiesData.campaign.operatorStrategyTypeId
    );
    const {
        update: hasCampaignsUpdatePermission,
        delete: hasCampaignsDeletePermission,
    } = dialerPermissions;

    useEffect(() => {
        const handleResize = () => {
            setWindowWidth(window.innerWidth);
        };
        window.addEventListener('resize', handleResize);
        return () => {
            window.removeEventListener('resize', handleResize);
        };
    }, []);

    useEffect(() => {
        if (companiesData?.scheduler && companiesData?.scheduler?.days?.length) {
            const labelsMap = weekdayField.reduce((map, weekday) => {
                // @ts-ignore
                map[weekday.dayOfWeek] = weekday.label;
                return map;
            }, {});

            const updatedDays = companiesData?.scheduler?.days?.map((day: { dayOfWeek: string | number; label: any; }) => ({
                ...day,
                // @ts-ignore
                label: labelsMap[day.dayOfWeek] || day.label
            }));

            updatedDays.sort((a: { dayOfWeek: number; }, b: { dayOfWeek: number; }) => {
                const dayOfWeekA = a.dayOfWeek === 0 ? 7 : a.dayOfWeek;
                const dayOfWeekB = b.dayOfWeek === 0 ? 7 : b.dayOfWeek;
                return dayOfWeekA - dayOfWeekB;
            });
            setUpdatedScheduler({
                ...companiesData?.scheduler,
                days: updatedDays
            });
        } else {
            setUpdatedScheduler(companiesData?.scheduler)
        }
    }, [companiesData?.scheduler]);

    const weekdayBodyTemplate = (days: { [x: string]: any; }, day: number) => {
        const currentDay = days[day];
        const start = days[day]?.start;
        if (!currentDay) {
            return <div className="grid col-12 md:col-12 flex align-items-center" style={{minWidth: '12%'}}>
                - - -
            </div>;
        }
        return (
            <div className="grid flex align-items-center">
                {start ? <div className="col-12 md:col-12 flex align-items-center pl-0" style={{minWidth: '12%'}}>
                        <Calendar disabled className="opacity-100 text-white queue-time" mask="99:99" value={new Date(currentDay.start)} timeOnly style={{minWidth: '60px'}}/>
                    </div> :
                    <div className="col-12 md:col-12 flex align-items-center pl-0">
                        <Calendar disabled className="opacity-100 text-white queue-time" mask="99:99" value={new Date(currentDay.end)} timeOnly style={{minWidth: '60px'}}/>
                    </div>}
            </div>
        );
    };

    const titleBodyTemplate = (days: { [x: string]: any; }) => {
        const start = days[0]?.start;
        return (
            <div className="grid flex align-items-center">
                {start ? <div className="col-6 md:col-6 flex align-items-center" style={{minWidth: '12%'}}>
                        <div className="mr-2">
                            <label>З</label>
                        </div>
                    </div> :
                    <div className="col-6 md:col-6 flex align-items-center">
                        <div className="mr-2">
                            <label>По</label>
                        </div>
                    </div>}
            </div>
        );
    };

    let startDates: any = {};
    let endDates: any = {};

    updatedScheduler?.days?.forEach((day: { dayOfWeek: any; start: any; end: any; label: any; }) => {
        const {dayOfWeek, start, end, label} = day;
        startDates[dayOfWeek] = {dayOfWeek, start, label};
        endDates[dayOfWeek] = {dayOfWeek, end, label};
    });

    let cancelNotification = getItem(codes.cancel);
    let launchNotification = getItem(codes.launch);
    let suspendNotification = getItem(codes.suspend);

    const progressBar = <ProgressBar mode="indeterminate" style={{height: '2px', maxWidth: '95%'}}></ProgressBar>;

    // @ts-ignore
    let launchMessage = <div>{companies && companies.notificationLaunch ? companies.notificationLaunch.text : launchNotification ? launchNotification : progressBar}</div>
    // @ts-ignore
    let cancelMessage = <div>{companies && companies.notificationCancel ? companies.notificationCancel.text : cancelNotification ? cancelNotification : progressBar}</div>
    // @ts-ignore
    let suspendMessage = <div>{companies && companies.notificationSuspend ? companies.notificationSuspend.text : suspendNotification ? suspendNotification : progressBar}</div>

    const statusesDict = [
        {name: 'DRAFT', code: 1},
        {name: 'IDLE', code: 2},
        {name: 'ACTIVE', code: 3},
        {name: 'PAUSE', code: 4},
        {name: 'CANCEL', code: 5},
        {name: 'DONE', code: 6},
    ];

    const getNotificationMessage = (type: number) => {
        switch (type) {
            case 1:
                if (!cancelNotification && user.userId) {
                    dispatch(getNotification(user.userId, 107, user));
                }
                setCancelNotificationStatusChange(true);
                break;
            case 2:
                if (!launchNotification && user.userId) {
                    dispatch(getNotification(user.userId, 105, user));
                }
                setLaunchNotificationStatusChange(true);
                break;
            case 3:
                if (!suspendNotification && user.userId) {
                    dispatch(getNotification(user.userId, 106, user));
                }
                setSuspendNotificationStatusChange(true);
                break;
            default:
        }
    }

    const formatDate = (fullDate: string) => {
        const date = new Date(fullDate);

        const year = date.getFullYear();
        const month = date.getMonth() + 1;
        const day = date.getDate();

        const formattedMonth = month < 10 ? `0${month}` : month;
        const formattedDay = day < 10 ? `0${day}` : day;

        return `${formattedDay} / ${formattedMonth} / ${year}`;
    }

    const formatTime = (fullDate: string) => {
        const date = new Date(fullDate);

        const hours = date.getHours();
        const minutes = date.getMinutes();
        const seconds = date.getSeconds();

        const formattedHours = hours < 10 ? `0${hours}` : hours;
        const formattedMinutes = minutes < 10 ? `0${minutes}` : minutes;
        const formattedSeconds = seconds < 10 ? `0${seconds}` : seconds;

        return `${formattedHours}:${formattedMinutes}:${formattedSeconds}`;
    }

    const campaignTypeBodyTemplate = () => {
        return companiesDirectoryCampaignType.map((item: any) => {
            if (item.dictionaryId === companiesData.campaign?.campaignTypeId) {
                return item.name
            }
        });
    };

    const operatorsBodyTemplate = () => {
        const activeOperators = companiesData.campaign?.activeOperators;
        const countUsers = companiesData.campaign?.countUsers;

        if (activeOperators !== undefined && countUsers !== undefined) {
            return `${activeOperators} / ${countUsers}`;
        }
    }

    const strategyTemplate = () => {
        const strategy = companiesDirectoryCampaignStrategy.find(
            (item: { dictionaryId: any; }) => item.dictionaryId === companiesData.campaign.operatorStrategyTypeId
        );

        return (
            <>
                {!companiesData.campaign.IsGeneralUser && (
                    <div className="field col-12 md:col-12">
                            {strategy?.name || '—'}
                    </div>
                )}
            </>
        );
    }

    const countContactsBodyTemplate = () => {
        const countContacts = companiesData.campaign?.countContacts;

        if (countContacts !== undefined) {
            return `${countContacts}`;
        }
    }

    const statusBodyTemplate = () => {
        let statusName = statusesDict.map((item) => {
            if (item.code === companiesData.campaign?.statusId) {
                return item.name
            }
        })
        return <span className={`customer-badge status-${companiesData.campaign?.statusId}`}>{statusName}</span>;
    };

    const branchBodyTemplate = () => {
        if (companiesData?.permission?.branchIsBlock) {
            return (
                <div className="mt-1">
                    <span style={{verticalAlign: 'middle'}} className="image-text">
                        {companiesData.campaign?.branchId} {companiesData.campaign?.branchName}
                    </span>
                </div>
            );
        }

        let element = branches?.find((element: { id: number; }) => element?.id === companiesData.campaign?.branchId);

        return (
            <div className="mt-1">
                <span style={{verticalAlign: 'middle'}} className="image-text">
                    {element?.id} {element?.name}
                </span>
            </div>
        );
    };

    const isInLineCountCallsBodyTemplate = () => {
        return (
            <div>
                {companiesData.campaign?.campaignTypeId === 202 ? !companiesData.campaign?.isInLineCountCalls ? 'Задана кількість' : companiesData.campaign?.isInLineCountCalls ? 'Кількість EWT' : '' : ''}
            </div>
        )
    }

    const inLineCountCallsBodyTemplate = () => {
        return (
            <div>
                {!companiesData.campaign?.isInLineCountCalls ? companiesData.campaign?.inLineCountCalls : ''}
            </div>
        )
    }

    let callStartTime = companiesData.scheduler?.startTime ? formatTime(companiesData.scheduler?.startTime) : '- - -';
    let callEndTime = companiesData.scheduler?.endTime ? formatTime(companiesData.scheduler?.endTime) : '- - -';
    const fields = [
        {label: "ID", value: companiesData.campaign?.campaignId},
        {label: "Branch", value: companiesData.campaign?.branchId ? branchBodyTemplate() : '- - -'},
        {label: "Тип", value: companiesData.campaign?.campaignId ? campaignTypeBodyTemplate() : '- - -'},
        ...(companiesData.campaign?.campaignTypeId === 202 ? [
            {label: "Кількість викликів", value: companiesData.campaign ? isInLineCountCallsBodyTemplate() : '- - -'},
            {label: "Кількість одночасних викликів", value: companiesData.campaign?.inLineCountCalls ? inLineCountCallsBodyTemplate() : '- - -'}
        ] : []),
        {label: "Транк", value: companiesData?.campaign?.isGeneralTrunk ? 'Транк Кампанії' : 'Транк Оператора'},
        {label: "Напрямок дзвінків:", value: companiesData.campaign.firstCallOperator ? 'На оператора' : 'На клієнта'},
        {label: "Умови запуску", value: companiesData.scheduler?.typeEventStart ? 'В період' : '- - -'},
        {label: "Дата запуску", value: companiesData.scheduler?.startDate ? formatDate(companiesData.scheduler?.startDate) : '- - -'},
        {label: "Дата завершення:", value: companiesData.scheduler?.endDate ? formatDate(companiesData.scheduler?.endDate) : '- - -'},
        {label: "Розклад дзвінків:", value: companiesData?.scheduler ? `з-: ${callStartTime}  по- ${callEndTime}` : '- - -'},
        {label: "Оператори:", value: companiesData.campaign?.campaignId ? operatorsBodyTemplate() : '- - -'},
        {label: "Активних контактів:", value: companiesData.campaign?.campaignId ? countContactsBodyTemplate() : '- - -'},
        {label: "Успішно:", value: companiesData.campaign?.isDoneContactCount ? companiesData.campaign?.isDoneContactCount : '0'},
    ];

    const campaignDataSort = {
        pageNumber: campaignContactsPageSize.page,
        pageSize: campaignContactsPageSize.size,
        sort: {
            orderBy: "ContactName",
            "isDesc": false
        },
        campaignId: null
    }

    const openEditor = () => {
        dispatch(setSelectedCompanyIndex(companiesData.campaign?.campaignId || props.selectedRowData));
        dispatch(setDialogVisible(true));
        dispatch(setErrorFields(null));
        campaignDataSort.campaignId = props.selectedRowData;
        if (props.setSelectedRowData) {
            props.setSelectedRowData(null);
        }
        if (hasCampaignsUpdatePermission) {
            dispatch(setEditType(true));
        } else {
            dispatch(setEditType(false));
        }
    }

    const StateCampaign = {
        "campaignId": companiesData?.campaign?.campaignId,
        "statusId": null,
        "userId": user?.userId
    }

    const updateCampaign = (campaignData: any, statusId: number) => {
        campaignData.statusId = statusId;
        dispatch(updateStateCampaign(campaignData, jwtToken?.jwtToken))
        if (statusId === 5) {
            dispatch(setDialogVisible(false));
        }
    };

    // function getProgressBarColor(percent: number) {
    //     return percent <= 10 ? '#98ceec' :
    //         percent <= 20 ? '#84c1e7' :
    //             percent <= 30 ? '#72b5e3' :
    //                 percent <= 40 ? '#64abdf' :
    //                     percent <= 50 ? '#529fdb' :
    //                         percent <= 60 ? '#4295d7' :
    //                             percent <= 70 ? '#348cd3' :
    //                                 percent <= 80 ? '#2783d0' :
    //                                     percent <= 90 ? '#1678cc' :
    //                                         percent <= 100 ? '#026bc7' : '#026bc7';
    // }
    //
    // function calculatePercentCount(percent: number) {
    //     return isNaN(percent) ? 0 : Math.round(percent);
    // }
    //
    // const isDoneContactCountPercent = () => {
    //     const percent = calculatePercentCount(companiesData?.campaign?.calledContactCount * 100 / companiesData?.campaign?.countContacts);
    //     const progressBarColor = getProgressBarColor(percent);
    //
    //     return (
    //         <div className="flex justify-content-center align-items-center justify-content-between w-full">
    //             <div className="mr-1">{percent}%</div>
    //             <ProgressBar color={progressBarColor} className='w-8 mr-2' showValue={false} value={percent}></ProgressBar>
    //         </div>
    //     )
    // }

    const settingsBodyTemplate = () => {
        return <div className="flex item controls-buttons">
            {hasCampaignsDeletePermission && (<div className="flex flex-column justify-content-center px-0">
                <span className="text-field pt-0">Відмінити</span>
                <Button disabled={!archiveTableToggle || !companiesData.campaign.campaignId || statusDone} onClick={() => getNotificationMessage(1)} icon="pi pi-stop" className="p-button-text my-0 mx-auto"/>
            </div>)}
            {statusId !== 2 && statusId !== 3 && hasCampaignsUpdatePermission ? <div className="flex flex-column justify-content-center">
                <span className="text-field pt-0">Запустити</span>
                <Button disabled={!archiveTableToggle || !companiesData.campaign.campaignId || statusDone} onClick={() => getNotificationMessage(2)} icon="pi pi-play" className="p-button-text my-0 mx-auto"/>
            </div> : ''}
            {statusId === 2 || statusId === 3 && hasCampaignsUpdatePermission ? <div className="flex flex-column justify-content-center">
                <span className="text-field pt-0">Призупинити</span>
                <Button disabled={!archiveTableToggle || !companiesData.campaign.campaignId || statusDone} onClick={() => getNotificationMessage(3)} icon="pi pi-pause" className="p-button-text my-0 mx-auto"/>
            </div> : <></>}
        </div>
    }

    const navigate = useNavigate();

    const openDetailsLink = () => {
        let href = window.location.origin + '#/campaign_details/' + companiesData.campaign.campaignId + '?childWindow=1'
        window.open(href, '_blank')
    }

    const copyDetailsLink = () => {
        let href = window.location.origin + '#/campaign_details/' + companiesData.campaign.campaignId
        const copyToClipboard = (text: string) => {
            const tempElement = document.createElement('textarea');
            tempElement.value = text;
            document.body.appendChild(tempElement);
            tempElement.select();
            document.execCommand('copy');
            document.body.removeChild(tempElement);
        }
        copyToClipboard(href);
        dispatch({type: SET_USER_STATUS_SUCCESS, payload: {message: 'Посилання скопійована в буфер обміну'}});
    }

    let windowForRender: any = windowWidth;

    useEffect(() => {
        if (!!props.profileMenuPin && windowWidth < 1550) {
            windowForRender = 1247;
        }
    }, [windowWidth]);

    useEffect(() => {
        if (!!props.profileMenuPin && windowWidth < 1550) {
            windowForRender = 1247;
        }
    }, [props.profileMenuPin]);

    const trunkName = (rowData: any) => {
        const foundItem = companiesDirectoryTranksPhones?.find((item: { sofiaTrunkId: number; }) => item.sofiaTrunkId === rowData?.trunkId);
        const inactive = assignedTrunkIsInactive(rowData);
        const name = rowData?.trunkName || foundItem?.profileName || '';
        return (
            <p className={classNames('relative flex align-items-center m-0 w-full', {'opacity-60': inactive})} style={inactive ? {paddingRight: '1.75rem'} : undefined}>
                <span>{trunkInactiveLabel(name)}</span>
                {inactive ? <TrunkInactiveIcon /> : null}
            </p>
        );
    }

    const trunkNumber = (rowData: any) => {
        const foundItem = companiesDirectoryTranksPhones?.find((item: { id: number; }) => item.id === rowData?.trunkPhoneId);
        const phone = rowData?.phoneNo || foundItem?.phoneNo || '';
        if (!phone) {
            return <p></p>;
        }
        const inactive = assignedPhoneIsInactive(rowData);
        return (
            <p className={classNames('relative flex align-items-center m-0 w-full', {'opacity-60': inactive})} style={inactive ? {paddingRight: '1.75rem'} : undefined}>
                <span>{phone}</span>
                {inactive ? <TrunkInactiveIcon/> : null}
            </p>
        );
    }

    return (
        <div className="">
            <div className="relative">
                {loader && <ProgressBar mode="indeterminate" style={{height: '6px'}}></ProgressBar>}
                <div className={classNames('grid', {'opacity-50': loader})} style={{paddingTop: "0.3rem", padding: '0.3rem 10px 5px'}}>
                    {windowWidth > 1248 && <div className="grid flex-wrap col-12 md:col-12 mb-0 flex">
                        <div className="field col-12 md:col-2 flex align-items-center m-0 p-0">
                            <div className="w-full mb-2">ID: {companiesData.campaign?.campaignId}</div>
                        </div>
                        <div className="field col-12 md:col-3 flex align-items-center m-0 p-0">
                            <div className="w-full">Оператори: {companiesData.campaign?.campaignId ? operatorsBodyTemplate() : '- - -'}</div>
                        </div>
                        <div className="field col-12 md:col-2 flex align-items-center m-0 p-0">
                            <div className="w-full">Тип: {companiesData.campaign?.campaignId ? campaignTypeBodyTemplate() : '- - -'}</div>
                        </div>
                        <div className="field col-12 md:col-3 flex align-items-center m-0 p-0">
                            <div className="w-full flex justify-content-between max-w-16rem"><span>Активних контактів:</span> {companiesData.campaign?.campaignId ? countContactsBodyTemplate() : '- - -'}</div>
                        </div>
                        <div className="field col-12 md:col-2 flex align-items-center justify-content-end m-0 p-0">
                            <div className="field col-12 md:col-5 flex align-items-center justify-content-end m-0 p-0 mr-4">
                                {statusBodyTemplate()}
                            </div>
                            <div className="field col-12 md:col-6 flex align-items-center m-0 p-0">
                                <button className={`close-button block cursor-pointer`} onClick={() => {
                                    openEditor();
                                }}><span className={classNames('', {
                                    'pi pi-pencil': archiveTableToggle && hasCampaignsUpdatePermission,
                                    'pi pi-eye': !archiveTableToggle || !hasCampaignsUpdatePermission
                                })}></span></button>
                                <button className="close-button block cursor-pointer ml-2"
                                        onClick={() => {
                                            copyDetailsLink();
                                        }
                                        }><span className="pi pi-copy"></span>
                                </button>
                                {!props.isWindow && <button className="close-button block cursor-pointer ml-2 mr-2"
                                                            onClick={() => {
                                                                openDetailsLink();
                                                            }
                                                            }><span className="pi pi-arrow-up-right-and-arrow-down-left-from-center"></span>
                                </button>}
                                {!props?.isWindow && <button className="close-button block cursor-pointer ml-0" onClick={() => props.setSelectedRowData(null)}><span className="pi pi-times"></span></button>}
                            </div>
                        </div>
                        <div className="field col-12 md:col-2 flex align-items-center m-0 p-0">
                            <p className="w-full font-bold">{companiesData.campaign?.campaignName}</p>
                        </div>
                        <div className="field col-12 md:col-3 flex align-items-center m-0 p-0">
                            <div className="w-full">
                                Стратегія операторів: {' '}
                                {companiesData.campaign?.campaignId ? (
                                    !companiesData.campaign.IsGeneralUser ? (
                                        <span>{strategy?.name || '—'}</span>
                                    ) : (
                                        '—'
                                    )
                                ) : (
                                    '- - -'
                                )}
                            </div>
                        </div>
                        <div className="field col-12 md:col-2 flex align-items-center m-0 p-0">
                            <p className="w-full">Напрямок: {companiesData.campaign.firstCallOperator ? 'На оператора' : 'На клієнта'}</p>
                        </div>
                        <div className="field col-12 md:col-3 flex align-items-center m-0 p-0">
                            {/*<div className="w-full max-w-16rem">{isDoneContactCountPercent()}</div>*/}
                        </div>
                    </div>}

                    {windowWidth > 1248 && <Divider className="m-0"/>}
                    {windowWidth > 1248 && <Divider className="m-0"/>}
                    {windowWidth > 1248 && companiesData.campaign?.campaignTypeId === 202 && <div className="field col-12 md:col-12 flex flex-wrap align-items-center m-0 px-0 pb-2">
                        <div className="field col-12 md:col-12 flex align-items-center m-0 p-0">
                            <p className="w-20rem m-0">Кількість викликів:</p>
                            <p className="m-0 ml-2">{isInLineCountCallsBodyTemplate()}</p>
                        </div>
                        <div className="field col-12 md:col-12 flex align-items-center m-0 p-0">
                            <p className="w-20rem m-0">Кількість одночасних викликів</p>
                            <p className="m-0 ml-2">{inLineCountCallsBodyTemplate()}</p>
                        </div>
                    </div>
                    }
                    {windowWidth > 1248 && <Divider className="m-0"/>}
                    {windowWidth > 1248 &&
                        <React.Fragment>
                            <div className="field col-12 md:col-12 flex align-items-center m-0 px-0 pb-2">

                                <div className="field col-12 md:col-3 flex align-items-center m-0 p-0">
                                    <p className="w-full">{companiesData?.campaign?.isGeneralTrunk ? 'Транк Кампанії' : 'Транк Оператора'}</p>
                                </div>
                                <div className="field col-12 md:col-2 flex align-items-center m-0 p-0">
                                    <p className="w-full">Бранч</p>
                                </div>
                                <div className={`field col-12  ${companiesData?.scheduler?.typeScheduler === 403 ? 'w-15rem' : 'w-18rem'} flex align-items-center m-0 p-0`}>
                                    <p className="w-full pl-2">Розклад роботи</p>
                                </div>
                                {companiesData?.scheduler?.typeScheduler === 403 && <div className="field col-12 w-22rem flex align-items-center m-0 p-0">
                                    <p className="w-full pl-2">Дата запуску: {companiesData.scheduler?.startDate ? formatDate(companiesData.scheduler?.startDate) : '- - -'}</p>
                                </div>}
                                <div className="field col-12 md:col-2 flex align-items-center m-0 p-0">
                                    {hasCampaignsDeletePermission && (<div className="flex flex justify-content-center px-0">
                                        <span className="text-field">Відмінити</span>
                                        <Button disabled={!archiveTableToggle || !companiesData.campaign.campaignId || statusDone} onClick={() => getNotificationMessage(1)} icon="pi pi-stop" className="p-button-text my-0 mx-auto"/>
                                    </div>)}
                                    {statusId !== 2 && statusId !== 3 && hasCampaignsUpdatePermission ? <div className="flex justify-content-center">
                                        <span className="text-field">Запустити</span>
                                        <Button disabled={!archiveTableToggle || !companiesData.campaign.campaignId || statusDone} onClick={() => getNotificationMessage(2)} icon="pi pi-play" className="p-button-text my-0 mx-auto"/>
                                    </div> : ''}
                                    {statusId === 2 || statusId === 3 && hasCampaignsUpdatePermission ? <div className="flex justify-content-center">
                                        <span className="text-field">Призупинити</span>
                                        <Button disabled={!archiveTableToggle || !companiesData.campaign.campaignId || statusDone} onClick={() => getNotificationMessage(3)} icon="pi pi-pause" className="p-button-text my-0 mx-auto"/>
                                    </div> : <></>}
                                </div>
                            </div>
                            <Divider className="mb-2 mt-0"/>
                            <div className="field col-12 md:col-12 flex m-0 scroll-detail-items p-0">
                                <div className="field col-12 md:col-3 flex m-0 p-0">
                                    {windowForRender > 1248 && <div className="field col-12 md:col-12 flex align-items-start m-0 p-0 scroll-detail-items">
                                        <div className="field col-12 md:col-12 flex align-items-center m-0 p-0">
                                            {companiesData.campaign.isGeneralTrunk ? <DataTable emptyMessage={<></>} value={companiesData.trunks} className="w-full">
                                                <Column body={trunkName} headerStyle={{display: 'none'}} style={{width: '15rem'}}/>
                                                <Column body={trunkNumber} headerStyle={{display: 'none'}} style={{width: '15rem'}}/>
                                            </DataTable> : '- - -'}
                                        </div>
                                    </div>}
                                </div>
                                <div className="field col-12 md:col-2 flex m-0 p-0 flex-wrap">
                                    {companiesData.campaign?.branchId ? branchBodyTemplate() : '- - -'}
                                </div>
                                {companiesData?.scheduler?.typeScheduler !== 403 && <div className="field col-12 md:col-7 flex m-0 p-0">
                                    <DataTable className="col-12 md:col-12 pl-0 py-0 pr-0" value={[companiesData]}
                                    >
                                        <Column
                                            header={'Умови запуску'}
                                            className="justify-content-start align-content-start"
                                            body={(data) => data.scheduler?.typeEventStart ? 'В період' : '- - -'}
                                            style={{cursor: 'pointer'}}
                                        />
                                        <Column
                                            header={'Дата запуску'}
                                            className="justify-content-start align-content-start"
                                            body={(data) => data.scheduler?.startDate ? formatDate(companiesData.scheduler?.startDate) : '- - -'}
                                            style={{cursor: 'pointer'}}
                                        />
                                        <Column
                                            header={'Дата завершення'}
                                            className="justify-content-start align-content-start"
                                            body={(data) => data.scheduler?.endDate ? formatDate(companiesData.scheduler?.endDate) : '- - -'}
                                            style={{cursor: 'pointer'}}
                                        />
                                        <Column
                                            header={'Розклад дзвінків'}
                                            className="justify-content-start align-content-start"
                                            body={(data) => data?.scheduler ? <>
                                                <span>з- {callStartTime}</span> <span>по- {callEndTime}</span>
                                            </> : '- - -'}
                                            style={{cursor: 'pointer'}}
                                        />
                                        {/*<Column*/}
                                        {/*    header={'Управління кампанією'}*/}
                                        {/*    className="justify-content-start pt-2"*/}
                                        {/*    body={settingsBodyTemplate}*/}
                                        {/*    style={{cursor: 'pointer'}}*/}
                                        {/*/>*/}
                                    </DataTable>
                                </div>}
                                {companiesData?.scheduler?.typeScheduler === 403 &&
                                    <div className="field col-12 md:col-7 flex m-0 p-0">
                                        {updatedScheduler?.days?.length ?
                                            <DataTable className="col-12 md:col-12 p-0 py-0" value={[startDates, endDates]}>
                                                <Column
                                                    header={''}
                                                    headerClassName="pt-0"
                                                    className="justify-content-start"
                                                    body={(data) => titleBodyTemplate(data)}
                                                    style={{cursor: 'pointer', width: '5%'}}
                                                />
                                                <Column
                                                    header={'Пн'}
                                                    headerClassName="pt-0"
                                                    className="justify-content-start"
                                                    body={(data) => weekdayBodyTemplate(data, 1)}
                                                    style={{cursor: 'pointer', width: '12%'}}
                                                />
                                                <Column
                                                    header={'Вт'}
                                                    headerClassName="pt-0"
                                                    className="justify-content-start"
                                                    body={(data) => weekdayBodyTemplate(data, 2)}
                                                    style={{cursor: 'pointer', width: '12%'}}
                                                />
                                                <Column
                                                    header={'Ср'}
                                                    headerClassName="pt-0"
                                                    className="justify-content-start"
                                                    body={(data) => weekdayBodyTemplate(data, 3)}
                                                    style={{cursor: 'pointer', width: '12%'}}
                                                />
                                                <Column
                                                    header={'Чт'}
                                                    headerClassName="pt-0"
                                                    className="justify-content-start"
                                                    body={(data) => weekdayBodyTemplate(data, 4)}
                                                    style={{cursor: 'pointer', width: '12%'}}
                                                />
                                                <Column
                                                    header={'Пт'}
                                                    headerClassName="pt-0"
                                                    className="justify-content-start"
                                                    body={(data) => weekdayBodyTemplate(data, 5)}
                                                    style={{cursor: 'pointer', width: '12%'}}
                                                />
                                                <Column
                                                    header={'Сб'}
                                                    headerClassName="pt-0"
                                                    className="justify-content-start"
                                                    body={(data) => weekdayBodyTemplate(data, 6)}
                                                    style={{cursor: 'pointer', width: '12%'}}
                                                />
                                                <Column
                                                    header={'Нд'}
                                                    headerClassName="pt-0"
                                                    className="justify-content-start"
                                                    body={(data) => weekdayBodyTemplate(data, 0)}
                                                    style={{cursor: 'pointer', width: '12%'}}
                                                />
                                            </DataTable> : '---'}
                                    </div>}
                            </div>
                        </React.Fragment>
                    }
                    {windowWidth <= 1248 && <div className="grid col-12 md:col-12 mb-0 px-0">
                        <div className="field col-12 md:col-12 flex align-items-center m-0">
                            <p className="w-full">{companiesData.campaign?.campaignName}</p>
                        </div>
                        {(<div className="field col-12 md:col-12 p-0" style={{margin: 0, borderBottom: '1px solid #cccccc38'}}></div>)}
                    </div>}
                    {windowWidth <= 1248 && <div className="field col-6 md:col-6 flex align-items-center m-0">
                        {/*{isDoneContactCountPercent()}*/}
                    </div>}
                    {windowWidth <= 1248 && <div className="field col-6 md:col-6 flex align-items-center m-0 justify-content-end">
                        {statusBodyTemplate()}
                    </div>}
                    {windowWidth <= 1248 && fields.map((field: any) => (
                        <React.Fragment key={field.label}>
                            <div className="field col-12 md:col-6 flex align-items-center m-0">
                                <div>{field.label}</div>
                            </div>
                            <div className="field col-12 md:col-6 flex align-items-center m-0">
                                <div>{field.value}</div>
                            </div>
                        </React.Fragment>
                    ))}
                    {windowWidth <= 1248 && <div className="flex w-full">
                        <div className="field col-12 md:col-12">
                            <div className="flex item controls-buttons justify-content-center">
                                {hasCampaignsDeletePermission && (<div className="flex flex-column justify-content-center pt-0">
                                    <span className="text-field pt-0">Відмінити</span>
                                    <Button disabled={!archiveTableToggle || !companiesData.campaign.campaignId || statusDone} onClick={() => getNotificationMessage(1)} icon="pi pi-stop" className="p-button-text my-0 mx-auto"/>
                                </div>)}
                                {statusId !== 2 && statusId !== 3 && hasCampaignsUpdatePermission ? <div className="flex flex-column justify-content-center">
                                    <span className="text-field pt-0">Запустити</span>
                                    <Button disabled={!archiveTableToggle || !companiesData.campaign.campaignId || statusDone} onClick={() => getNotificationMessage(2)} icon="pi pi-play" className="p-button-text my-0 mx-auto"/>
                                </div> : ''}
                                {statusId === 2 || statusId === 3 && hasCampaignsUpdatePermission ? <div className="flex flex-column justify-content-center">
                                    <span className="text-field pt-0">Призупинити</span>
                                    <Button disabled={!archiveTableToggle || !companiesData.campaign.campaignId || statusDone} onClick={() => getNotificationMessage(3)} icon="pi pi-pause" className="p-button-text my-0 mx-auto"/>
                                </div> : <></>}
                            </div>
                        </div>
                    </div>}
                </div>
            </div>
            <ConfirmDialog visible={cancelNotificationStatusChange} onHide={() => setCancelNotificationStatusChange(false)} message={cancelMessage}
                           header="Попередження:" icon="pi pi-exclamation-triangle" acceptLabel="Продовжити" rejectLabel="Відмінити" accept={() => updateCampaign(StateCampaign, 5)}/>
            <ConfirmDialog visible={launchNotificationStatusChange} onHide={() => setLaunchNotificationStatusChange(false)} message={launchMessage}
                           header="Попередження:" icon="pi pi-exclamation-triangle" acceptLabel="Продовжити" rejectLabel="Відмінити" accept={() => updateCampaign(StateCampaign, 2)}/>
            <ConfirmDialog visible={suspendNotificationStatusChange} onHide={() => setSuspendNotificationStatusChange(false)} message={suspendMessage}
                           header="Попередження:" icon="pi pi-exclamation-triangle" acceptLabel="Продовжити" rejectLabel="Відмінити" accept={() => updateCampaign(StateCampaign, 4)}/>
        </div>
    )
}

export default CompaniesListDetails
